export default "__VITE_ASSET__BUniCGoj__"